export default {
  showBookingForm() {
    const contactUsPageId = '5bebc3ffa6f7db24edd92a80'
    return [contactUsPageId].includes(this.selectedArticle._id)
  },

  articleImages() {
    if (!this.selectedArticle) {
      return []
    }
    return this.galleriesByArticleId[this.selectedArticle._id] &&
      this.galleriesByArticleId[this.selectedArticle._id][0]
      ? this.galleriesByArticleId[this.selectedArticle._id][0].galleryImages
      : []
  },

  selectedArticle() {
    if (this.pagesById[this.id]) {
      return this.pagesById[this.id]
    } else if (this.pagesBySeoName[this.id]) {
      const redirectArticleId = this.pagesBySeoName[this.id].articleId
      if (redirectArticleId) {
        return this.pagesById[redirectArticleId]
      }
      return this.pagesBySeoName[this.id]
    }
    return {}
  },
}
